import React from "react"

import useQuestBoardStore from "./useQuestBoardStore"
import UserSelect from "../../components/userSelectHeader/UserSelectHeader"
import { UserSelectFilterType } from "../../types"

const QuestBoardUserSelectHeader = ({
  style,
}: {
  style?: React.CSSProperties
}) => {
  const {
    selectedUserId,
    setSelectedUserId,
    selectedFilterType,
    setSelectedFilterType,
  } = useQuestBoardStore()

  const onUserSelect = (
    filterType: UserSelectFilterType,
    userId: number | null
  ) => {
    if (filterType === UserSelectFilterType.USER) {
      setSelectedFilterType(UserSelectFilterType.USER)
      setSelectedUserId(userId)
    } else {
      setSelectedFilterType(filterType)
      setSelectedUserId(null)
    }
  }

  return (
    <UserSelect
      selectedUserId={selectedUserId}
      selectedFilterType={selectedFilterType}
      onUserSelect={onUserSelect}
      style={style}
    />
  )
}

export default QuestBoardUserSelectHeader
